export default "__VITE_ASSET__BgorCL3K__"